import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';

export interface AddFieldDialogData {
	fieldType: string;
	fieldTypeLabel: string;
	existingKeys: string[];
}

@Component({
	selector: 'nx-ahs-add-field-dialog',
	templateUrl: './add-field-dialog.component.html',
	styleUrl: './add-field-dialog.component.scss',
	standalone: false
})
export class AddFieldDialogComponent {
	fieldForm: FormGroup;

	constructor(
		public dialogRef: MatDialogRef<AddFieldDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AddFieldDialogData
	) {
		this.initializeForm();
	}

	private initializeForm(): void {
		this.fieldForm = new FormGroup({
			key: new FormControl('', [
				Validators.required,
				Validators.pattern(/^[a-zA-Z_][a-zA-Z0-9_]*$/),
				this.uniqueKeyValidator.bind(this)
			]),
			label: new FormControl('', [Validators.required]),
			placeholder: new FormControl(''),
			description: new FormControl(''),
			required: new FormControl(false),
			disabled: new FormControl(false)
		});
	}

	private uniqueKeyValidator(control: FormControl): Record<string, boolean> | null {
		if (control.value && this.data.existingKeys.includes(control.value)) {
			return { duplicate: true };
		}
		return null;
	}

	get keyControl() {
		return this.fieldForm.get('key');
	}

	get labelControl() {
		return this.fieldForm.get('label');
	}

	get keyErrorMessage(): string {
		if (this.keyControl?.hasError('required')) {
			return 'Key is required';
		}
		if (this.keyControl?.hasError('pattern')) {
			return 'Key must start with a letter or underscore and contain only letters, numbers, and underscores';
		}
		if (this.keyControl?.hasError('duplicate')) {
			return 'A field with this key already exists';
		}
		return '';
	}

	get labelErrorMessage(): string {
		if (this.labelControl?.hasError('required')) {
			return 'Label is required';
		}
		return '';
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onAdd(): void {
		if (this.fieldForm.valid) {
			this.dialogRef.close(this.fieldForm.value);
		}
	}
}
